import React, { Component } from 'react';
import { Col, Form, Input, message, Modal, Row, Select } from 'antd';

import { queryTransferContract } from '@api/xxcrm/contract';
import { queryAccountList } from '@api/core/user';
import SelectOrg from '../../comm/SelectOrg';

const FormItem = Form.Item;
const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountList: [],
      orgUuid: '',
    };
  }

  componentDidMount() {
    this.loadAccount();
  }

  submit = () => {
    const data = this.props.form.getFieldsValue();
    data.orgUuid = this.state.orgUuid;
    this.props.form.validateFields(err => {
      if (!err) {
        this.transferContract(data);
      }
    });
  };

  /**
   * 转移合同
   */
  transferContract = params => {
    params.uuids = this.props.uuids;
    queryTransferContract(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.handSubmit();
      } else {
        message.error(res.message);
      }
    });
  };

  onChangeOrg = value => {
    this.setState({
      orgUuid: value,
    });
    this.loadAccount(value);
    this.props.form.setFieldsValue({ userUuid: '' });
  };

  /**
   *获取用户列表
   */
  loadAccount = orgUuid => {
    const uuid = orgUuid || '';
    queryAccountList({ orgUuid: uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          accountList: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { cancel } = this.props;
    const { accountList } = this.state;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout2 = {
      labelCol: { span: 12 },
      wrapperCol: { span: 11 },
    };
    const formItemLayout3 = {
      labelCol: { span: 1 },
      wrapperCol: { span: 22 },
    };
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    return (
      <Modal
        title="转移合同"
        width={500}
        visible
        onCancel={cancel}
        onOk={this.submit}
        maskClosable={false}
      >
        <Form className="modal" layout="inline">
          <Row>
            <Col span={15}>
              <FormItem {...formItemLayout2} label="接收人" style={{ width: '100%' }}>
                {getFieldDecorator('orgUuid', {
                  rules: [{ required: true, message: '部门不能为空！' }],
                })(<SelectOrg onChange={this.onChangeOrg} orgUuid={this.state.orgUuid} />)}
              </FormItem>
            </Col>
            <Col span={7}>
              <FormItem {...formItemLayout3} style={{ width: '100%' }}>
                {getFieldDecorator('userUuid', {
                  rules: [{ required: true, message: '姓名不能为空！' }],
                })(
                  <Select placeholder="姓名">
                    {accountList.map(item => {
                      return <Option key={item.uuid}>{item.name}</Option>;
                    })}
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <FormItem {...formItemLayout} label="转移事由">
              {getFieldDecorator('remark')(
                <Input.TextArea
                  type="textarea"
                  size="large"
                  autosize={{ minRows: 2 }}
                  style={{ marginLeft: '5px' }}
                  maxLength={1000}
                />,
              )}
              <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
            </FormItem>
          </Row>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/contract/ModalTransfer.js